import type { FC } from "react";
import React, { useEffect } from "react";
import ProgramBloc from "src/state/ProgramBloc/ProgramBloc";
import { useBloc } from "src/state/state";
import ProgramPreviewCard from "src/ui/components/ProgramPreviewCard/ProgramPreviewCard";

const ProgramOverview: FC = () => {
  const [, programBloc] = useBloc(ProgramBloc);

  useEffect(() => {
    void programBloc.updatePrograms();
  }, []);

  return (
    <>
      <ProgramPreviewCard hideActions hideLink />
    </>
  );
};

export default ProgramOverview;
